import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { AnalyticsKpiApi } from "../../../api";
import { serializeError } from "../../../app/helpers";
import { RootState } from "../../../app/store";
import { ApiError } from "../../../app/types";

export interface AnalyticsKpiState {
  data: any;
  status: "idle" | "loading" | "failed";
  error?: ApiError;
}

const initialState: AnalyticsKpiState = {
  data: null,
  status: "idle",
};

export const fetchAnalyticsKpiControllerFindByOrganizationIdYearQuarterAsync = createAsyncThunk("analyticsKpis/fetch", async ({ organizationId, year }: { organizationId: string, year: number }, { rejectWithValue }) => {
  try {
    const analyticsKpisApi = new AnalyticsKpiApi();
    const response = await analyticsKpisApi.analyticsKpiControllerFindByOrganizationIdYearQuarter(organizationId, year);
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

const createExtraReducers = () => {
  const fetchAnalyticsKpiControllerFindByOrganizationIdYearQuarter = () => {
    const { pending, fulfilled, rejected } = fetchAnalyticsKpiControllerFindByOrganizationIdYearQuarterAsync;
    return {
      [`${pending}`]: (state: AnalyticsKpiState) => {
        state.status = "loading";
      },
      [`${fulfilled}`]: (state: AnalyticsKpiState, action: PayloadAction<any[]>) => {
        state.data = action.payload;
        state.status = "idle";
      },
      [`${rejected}`]: (state: AnalyticsKpiState, action: PayloadAction<AxiosError>) => {
        const error = serializeError(action.payload);
        state.status = "failed";
        state.error = error;
      },
    };
  };


  return { ...fetchAnalyticsKpiControllerFindByOrganizationIdYearQuarter() };
};

export const analyticsKpisSlice = createSlice({
  name: "analyticsKpis",
  initialState,
  reducers: {},
  extraReducers: createExtraReducers(),
});

export const selectAnalyticsKpis = (state: RootState) => state.analyticsKpis.data;

export default analyticsKpisSlice.reducer;
